import { actionTypes } from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_CONFIG_PROPERTIES_VALUE_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.GET_CONFIG_PROPERTIES_VALUE_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.GET_CONFIG_PROPERTIES_VALUE_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.GET_CONFIG_PROPERTIES_VALUE_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.GET_CONFIG_PROPERTIES_VALUE_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
